// English
export default {
    CustomSelect: {
        '请选择': 'Please select',
    },
    TopNav: {
        '创作者': 'Creator',
        '游客': 'Guest',
        '请登录后体验完整功能': 'Please login to experience full features',
        '登录': 'Login',
        '免费试用': 'Free Trial',
        '退出登录': 'Logout',
        '个人中心': 'Personal Center',
        '我的视频': 'My Videos',
        '额度管理': 'Quota Management',
        '首页': 'Home',
        'AI创作': 'AI',
        '多参考': 'Multi-reference',
        '文本视频': 'Text to Video',
        '图片视频': 'Image to Video',
        '文生图': 'Text to Image',
        '图生图': 'Image to Image',
        '会员中心': 'Member',
        '概览': 'Overview',
        '我的创作': 'My Creation',
        '账单管理': 'Billing Management',
        '生成任务': 'Generation Tasks',
        '价格': 'Pricing',
        '新闻资讯': 'News',
        '确定要退出登录吗？': 'Are you sure you want to log out?',
        '提示': 'Prompt',
        '确定': 'Confirm',
        '取消': 'Cancel',
        '退出成功': 'Logged out successfully',
        '视频展示': 'Showcases'
    },
    AiLayout: {
        'AI创作中心': 'AI Creation Center',
        '视频生成': 'Video Generation',
        '图片生成': 'Image Generation',
        '我的作品': 'My Works',
        '我的创作': 'My Creation',
        '今日剩余额度': 'Remaining quota today',
        '多参考': 'Multi-reference',
        '文本视频': 'Text to Video',
        '图片视频': 'Image to Video',
        '文生图': 'Text to Image',
        '图生图': 'Image to Image',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Next generation AI video generation platform, turn ideas into reality instantly',
        '产品': 'Product',
        'AI视频': 'AI Video',
        '价格方案': 'Pricing Plan',
        '新闻资讯': 'News',
        '支持': 'Support',
        '帮助中心': 'Help Center',
        'API文档': 'API Documentation',
        '常见问题': 'FAQ',
        '法律': 'Legal',
        '服务条款': 'Terms of Service',
        '隐私政策': 'Privacy Policy',
        '使用协议': 'User Agreement',
        '版权所有': 'All Rights Reserved',
        '客服邮箱': 'Customer Service Email',
        '复制邮箱': 'Copy Email',
        '开发中': 'Under development, please look forward to it!',
        '链接已复制到剪贴板': 'Link copied to clipboard',
    },
    MyLayout: {
        '创作者': 'Creator',
        '退出登录': 'Logout',
        '概览': 'Overview',
        '我的创作': 'My Creation',
        '会员中心': 'Member Center',
        '额度管理': 'Quota Management',
        '账单管理': 'Billing Management',
        '生成任务': 'Generation Tasks',
        '确定要退出登录吗？': 'Are you sure you want to log out?',
        '提示': 'Prompt',
        '确定': 'Confirm',
        '取消': 'Cancel',
        '退出成功': 'Logged out successfully'
    },
    Image: {
        "文本生成图片": "Text to Image",
        "图片生成图片": "Image to Image",
        "用文字描述": "Describe the picture you want with words",
        "上传图片素材": "Upload image materials, support multi-image generation",
        "图片描述": "Image Description",
        "描述您想要的图片": "Describe in detail the image content you want to generate, Chinese or English supported...",
        "提示描述越详细效果越好": "Tip: The more detailed the description, the better the generation effect",
        "图片素材": "Image Material",
        "预览图片": "Preview",
        "上传图片": "Upload Image",
        "支持格式JPGPNG": "Supports JPG, PNG formats",
        "最多": "At most",
        "张图片": "images",
        "超过大小限制": "Exceeds 10MB limit",
        "不是图片文件": "Not a valid image file",
        "最多上传": "You can upload up to",
        "请先上传图片": "Please upload image material first",
        "请选择要生成的图片": "Please select the image to generate",
        "生成结果": "Generation Result",
        "重新生成成功": "Regenerated successfully",
        "模型": "AI Model",
        "请选择模型": "Please select a generation model",
        "分辨率": "Output Resolution",
        "请选择分辨率": "Please select resolution",
        "图片比例": "Aspect Ratio",
        "补充描述": "Supplementary description (optional)",
        "补充描述提示": "Optional, describe any additional effects or styles you want the image to have",
        "开始绘制": "Start Drawing",
        "开始生成": "Start Generation",
        "生成中": "Generating, please wait...",
        "生成成功": "Generation successful",
        "图片生成成功": "Image generated successfully!",
        "作品已保存到我的作品": "Work has been saved to 'My Works'",
        "继续创作": "Continue creating",
        "查看作品": "View works",
        "请输入图片描述": "Please enter image description"
    },
    MyCreation: {
        '我的创作': 'My Creation',
        '查看和管理您的所有作品': 'View and manage all your works',
        '预览': 'Preview',
        '下载': 'Download',
        '编辑': 'Edit',
        '分享': 'Share',
        '删除': 'Delete',
        '暂无作品': 'No works yet',
        '去创作': 'Go create',
        '确定删除': 'Confirm delete',
        '确定要删除作品': 'Are you sure you want to delete the work',
        '吗？': '?',
        '此操作不可恢复': 'This operation cannot be undone, please proceed with caution!',
        '取消': 'Cancel',
        '分享作品': 'Share Work',
        '复制链接': 'Copy Link',
        '全部': 'All',
        '视频': 'Video',
        '图片': 'Image',
        '正在下载:': 'Downloading: ',
        '链接已复制到剪贴板': 'Link copied to clipboard',
        '删除成功': 'Deleted successfully'
    },
    Video: {
        "文本生成视频": "Text to Video",
        "图片生成视频": "Image to Video",
        "智能视频生成": "Intelligent Video Generation",
        "输入文字描述": "Enter text description",
        "上传1-9张图片": "Upload 1-9 images",
        "上传图片视频音频": "Upload image, video, audio",
        "视频描述": "Video Description",
        "描述您想要的视频场景": "Describe the video scene you want",
        "提示": "Tip",
        "图片素材": "Image Material",
        "最多上传": "Upload up to",
        "张": "images",
        "预览": "Preview",
        "上传图片": "Upload Image",
        "支持格式": "Supports JPG, PNG formats, single image up to 10MB, up to",
        "AI": "AI intelligent fusion, generating smooth transition effects for you",
        "动态描述": "Dynamic Description",
        "描述您希望图片如何动起来": "Describe how you want the image to move",
        "个": "items",
        "上传视频": "Upload Video",
        "上传音频": "Upload Audio",
        "描述您希望视频呈现的效果": "Describe the effect you want the video to present",
        "模型": "Model",
        "请选择模型": "Please select a model",
        "分辨率": "Resolution",
        "请选择分辨率": "Please select resolution",
        "宽高比": "Aspect Ratio",
        "视频时长": "Video Duration",
        "生成音频": "Generate Audio",
        "开启音效": "Enable Sound Effects",
        "静音模式": "Mute Mode",
        "音频提示": "Tip: Uploaded audio will be used as background music, AI will automatically generate music if no audio is uploaded",
        "开始生成": "Start Generation",
        "积分": "Credits",
        "生成中": "Generating",
        "生成成功": "Generated successfully",
        "视频生成成功！": "Video generated successfully!",
        "作品已保存到": "Work has been saved to 'My Works'",
        "继续创作": "Continue creating",
        "查看作品": "View works",
        "视频预览": "Video Preview",
        "关闭": "Close",
        "下载视频": "Download Video",
        "您的浏览器不支持视频播放": "Your browser does not support video playback",
        "生成进度": "Generation Progress",
        "描述": "Description",
        "时长": "Duration",
        "秒": "seconds",
        "视频素材": "Video Material",
        "音频素材": "Audio Material",
        "双图融合模式": "Dual-image Fusion Mode",
        "开始下载视频": "Start downloading video",
        "请输入视频描述": "Please enter video description",
        "请至少上传一张图片": "Please upload at least one image",
        "请至少上传一张图片或一个视频": "Please upload at least one image or one video",
        "最多只能上传": "You can only upload up to",
        "超过": "Exceeds",
        "限制": "limit",
        "不是图片文件": "Not an image file",
        "不是视频文件": "Not a video file",
        "不是音频文件": "Not an audio file"
    },
    Forgot: {
        "找回密码": "Retrieve Password",
        "请输入您的邮箱，我们将发送验证码": "Please enter your email, we will send a verification code",
        "密码重置成功，请使用新密码登录": "Password reset successful, please log in with new password",
        "密码重置成功": "Password reset successful",
        "您的密码已成功重置，请使用新密码登录": "Your password has been successfully reset, please log in with your new password",
        "立即登录": "Log in immediately",
        "邮箱": "Email",
        "请输入注册邮箱": "Please enter registered email",
        "发送验证码": "Send verification code",
        "请输入验证码": "Please enter verification code",
        "验证码": "Verification Code",
        "新密码": "New Password",
        "设置新密码": "Set new password",
        "确认新密码": "Confirm new password",
        "再次输入新密码": "Enter new password again",
        "重置密码": "Reset Password",
        "返回登录": "Back to login",
        "验证中": "Verifying",
        "重置中": "Resetting",
        "弱": "Weak",
        "中": "Medium",
        "强": "Strong",
        "请输入邮箱地址": "Please enter email address",
        "请输入正确的邮箱格式": "Please enter the correct email format",
        "验证码应为6位数字": "The verification code should be 6 digits",
        "请输入新密码": "Please enter a new password",
        "密码至少需要6位": "Password requires at least 6 characters",
        "请再次输入新密码": "Please enter new password again",
        "两次输入的密码不一致": "The passwords entered twice do not match",
        "验证码已发送": "Verification code sent"
    },
    Login: {
        "下一代AI视频生成平台": "Next generation AI video generation platform",
        "一键生成": "One-click generation",
        "支持4K超高清输出": "Supports 4K Ultra HD output",
        "多种风格模板任选": "Multiple style templates to choose from",
        "商用授权无忧使用": "Commercial authorization for worry-free use",
        "欢迎回来": "Welcome back",
        "登录您的账号继续创作": "Log in to your account to continue creating",
        "邮箱": "Email",
        "请输入邮箱地址": "Please enter email address",
        "密码": "Password",
        "请输入您的密码": "Please enter your password",
        "记住我": "Remember me",
        "忘记密码？": "Forgot password?",
        "登录": "Log in",
        "登录中": "Logging in",
        "还没有账号？": "Don't have an account yet?",
        "立即注册": "Register now",
        "请输入正确的邮箱格式": "Please enter the correct email format",
        "请输入密码": "Please enter password",
        "密码至少需要6位": "Password requires at least 6 characters",
        "密码不能超过20位": "Password cannot exceed 20 characters",
        "登录成功": "Logged in successfully"
    },
    Register: {
        "创建账号": "Create Account",
        "开始您的AI视频创作之旅": "Start your AI video creation journey",
        "姓名": "Name",
        "请输入您的姓名": "Please enter your name",
        "邮箱": "Email",
        "请输入邮箱地址": "Please enter email address",
        "获取验证码": "Get Verification Code",
        "验证码": "Verification Code",
        "请输入验证码": "Please enter verification code",
        "密码": "Password",
        "设置密码": "Set Password",
        "确认密码": "Confirm Password",
        "再次输入密码": "Enter password again",
        "我已阅读并同意": "I have read and agree to",
        "服务条款": "Terms of Service",
        "和": "and",
        "隐私政策": "Privacy Policy",
        "注册中": "Registering",
        "已有账号？": "Already have an account?",
        "立即登录": "Log in immediately",
        "弱": "Weak",
        "中": "Medium",
        "强": "Strong",
        "请输入姓名": "Please enter name",
        "姓名至少需要2个字符": "Name requires at least 2 characters",
        "姓名不能超过20个字符": "Name cannot exceed 20 characters",
        "请输入正确的邮箱格式": "Please enter the correct email format",
        "验证码应为6位数字": "The verification code should be 6 digits",
        "请输入密码": "Please enter password",
        "密码至少需要6位": "Password requires at least 6 characters",
        "密码不能超过20位": "Password cannot exceed 20 characters",
        "请再次输入密码": "Please enter password again",
        "两次输入的密码不一致": "The passwords entered twice do not match",
        "验证码已发送": "Verification code sent",
        "注册成功": "Registered successfully"
    },
    Faq: {
        '常见问题': 'Frequently Asked Questions',
        '您在使用过程中遇到的问题': 'You can find answers to problems you encounter during use here',
        '搜索您的问题': 'Search for your question...',
        '没有找到相关的问题': 'No related questions found',
        '查看全部问题': 'View all questions',
        '没有找到您想要的答案？': 'Did not find the answer you wanted?',
        '我们的客服团队随时为您提供帮助': 'Our customer service team is always ready to help you',
        '复制客服邮箱': 'Copy customer service email',
        '链接已复制到剪贴板': 'Link copied to clipboard'
    },
    Home: {
        '立即订阅': 'Subscribe Now',
        'AI视频生成新时代': 'A new era of AI video generation',
        '用文字创造': 'Create Infinite ',
        '无限视频': 'Videos with Text',
        '让每个人都能成为视频创作者': 'Let everyone be a video creator. Just enter text description to generate high-quality, unique AI videos.',
        '免费开始': 'Start for free',
        '观看演示': 'Watch Demo',
        'AI生成': 'AI Generated',
        'AI视频': 'AI Video',
        '三步轻松生成专业视频': 'Easily generate professional videos in three steps',
        '输入提示词': 'Enter prompt words',
        '用文字描述您想要的视频内容': 'Describe the video content you want with words, the more detailed the better',
        '智能生成': 'Intelligent Generation',
        'AI模型自动理解并创作': 'AI models automatically understand and create, rendering in a few minutes',
        '下载作品': 'Download works',
        '高清视频生成完成': 'HD video generation completed, ready for download and use',
        'AI视频生成': 'AI Video Generation',
        '精彩视频': 'Enter text description, AI will generate wonderful videos for you',
        '描述您想要的视频场景': 'Describe the video scene you want, for example: a cat playing under a cherry blossom tree, sunlight shining through the petals...',
        '生成中': 'Generating...',
        '生成视频': 'Generate Video',
        'AI图片': 'AI Image',
        '精美图片': 'Enter text description, AI will generate for you',
        '描述您想要的图片场景': 'Describe the image scene you want, for example: skyline of a future city, flashing neon lights, cyberpunk style...',
        '生成图片': 'Generate Image',
        '强大功能': 'Powerful Features',
        '让视频创作变得简单有趣': 'Make video creation simple and fun',
        '案例展示': 'Case Showcase',
        '来看看用户使用': 'Come and see what users are using',
        '创作的精彩作品': 'wonderful works created',
        '新闻资讯': 'News',
        '了解': 'Learn',
        '的最新动态和产品更新': 'latest news and product updates',
        '查看更多': 'View more',
        '热门': 'Popular',
        '最新': 'Latest',
        '阅读更多': 'Read more',
        '选择适合您的方案': 'Choose the plan that suits you',
        '灵活的定价': 'Flexible pricing to meet different needs',
        '视频预览': 'Video Preview',
        '生成成功': 'Generated successfully',
        '作品已保存到': 'Work has been saved to "My Creation"',
        '继续创作': 'Continue creating',
        '查看作品': 'View works',
        '请输入视频描述': 'Please enter video description',
        '视频生成成功！': 'Video generated successfully!',
        '请输入图片描述': 'Please enter image description',
        '图片生成成功！': 'Image generated successfully!'
    },
    News: {
        '新闻资讯': 'News',
        '了解': 'Learn',
        '的最新动态和产品更新': 'latest news and product updates',
        '精选': 'Featured',
        '阅读': 'Read',
        '点赞': 'Like',
        '热门': 'Popular',
        '最新': 'Latest',
        '阅读更多': 'Read more',
        '加载中': 'Loading...',
        '暂无新闻': 'No news yet',
        '清除筛选': 'Clear filter',
        '加载新闻失败': 'Failed to load news, please try again later',
    },
    Price: {
        '选择适合您的方案': 'Choose the plan that suits you',
        '灵活的定价': 'Flexible pricing to meet different needs',
        '包月': 'Monthly',
        '包年': 'Yearly',
        '购买积分': 'Buy Credits',
        '只需要几个视频': 'Only need a few videos? No subscription needed, buy credit packs directly',
        '产品大全': 'All Products',
        '了解': 'Learn',
        '全系列产品的详细信息和支付方式': 'detailed information and payment methods for a full range of products'
    },
    Billing: {
        '账单管理': 'Billing Management',
        '账户余额': 'Account Balance',
        '本月支出': 'This month\'s expenditure',
        '订单数量': 'Number of orders',
        '账单列表': 'Bill List',
        '请选择类型': 'Please select type',
        '请选择时间范围': 'Please select time range',
        '订单号': 'Order Number',
        '类型': 'Type',
        '金额': 'Amount',
        '状态': 'Status',
        '时间': 'Time',
        '操作': 'Operation',
        '查看详情': 'View Details',
        '下载发票': 'Download Invoice',
        '暂无作品': 'No works yet',
        '去创作': 'Go create',
        '支付方式': 'Payment Method',
        '添加支付方式': 'Add Payment Method',
        '默认': 'Default',
        '设为默认': 'Set as Default',
        '编辑': 'Edit',
        '删除': 'Delete',
        '账单详情': 'Bill Details',
        '交易流水号': 'Transaction Serial Number',
        '关闭': 'Close',
        '账号': 'Account/Card Number',
        '请输入账号或卡号': 'Please enter account or card number',
        '姓名': 'Name',
        '请输入持卡人姓名': 'Please enter cardholder name',
        '有效期': 'Validity Period',
        '请输入CVV码': 'Please enter CVV code',
        '取消': 'Cancel',
        '确认添加': 'Confirm Add',
        '确认修改': 'Confirm Edit',
        '确认删除': 'Confirm Delete',
        '编辑支付方式': 'Edit Payment Method',
        '确定要删除支付方式': 'Are you sure you want to delete the payment method',
        '删除后不可恢复': 'It cannot be restored after deletion, please proceed with caution!',
        '请输入账号': 'Please enter account/card number',
        '添加成功': 'Added successfully',
        '修改成功': 'Edited successfully',
        '已设为默认支付方式': 'Set as default payment method',
        '删除成功': 'Deleted successfully',
    },
    Credit: {
        '额度管理': 'Quota Management',
        '当前可用额度': 'Currently available quota',
        '升级会员': 'Upgrade Member',
        '本月已用': 'Used this month',
        '视频生成': 'Video Generation',
        'AI图片': 'AI Image',
        '其他': 'Other',
        '购买额度包': 'Buy Quota Pack',
        '最受欢迎': 'Most Popular',
        '额度': 'Quota',
        '立即购买': 'Buy Now',
        '使用记录': 'Usage Record',
        '操作': 'Operation',
        '类型': 'Type',
        '额度变动': 'Quota Change',
        '时间': 'Time',
        '购买': 'Buy',
        '确认购买': 'Confirm Purchase',
        '金额': 'Amount: ',
        '获得': 'Get',
        '取消': 'Cancel',
        '今天': 'Today',
        '昨天': 'Yesterday',
    },
    Dashboard: {
        '欢迎回来': 'Welcome back, ',
        '创建新视频': 'Create New Video',
        '本月生成次数': 'Number of generations this month',
        '剩余额度': 'Remaining quota',
        '总视频数': 'Total Videos',
        '会员状态': 'Member Status',
        '最近生成': 'Recently Generated',
        '查看全部': 'View All',
        '视频预览': 'Video Preview',
        '视频生成中': 'Video is generating, please preview later',
    },
    Membership: {
        '会员中心': 'Member Center',
        '当前方案': 'Current Plan',
        'Pro 会员': 'Pro Member',
        '专业创作者首选': 'Preferred by professional creators',
        '月': 'Month',
        '会员有效期': 'Membership validity period',
        '剩余天数': 'Remaining days',
        '续费会员': 'Renew Membership',
        '取消订阅': 'Cancel Subscription',
        '本月使用情况': 'Usage this month',
        '视频生成': 'Video Generation',
        '次': 'times',
        '额度使用': 'Quota Usage',
        '快速生成': 'Fast Generation',
        '升级方案': 'Upgrade Plan',
        '联系销售': 'Contact Sales',
        '会员权益': 'Member Benefits',
        '续费后将延长会员有效期30天': 'After renewal, membership validity will be extended by 30 days',
        '取消': 'Cancel',
        '确认续费': 'Confirm Renewal',
        '取消后您将失去所有会员权益': 'After cancellation, you will lose all member benefits, and remaining quota will be retained',
        '再想想': 'Think Again',
        '确认取消': 'Confirm Cancel',
        '姓名': 'Name',
        '请输入您的姓名': 'Please enter your name',
        '请输入姓名': 'Please enter name',
        '公司': 'Company',
        '请输入公司名称': 'Please enter company name',
        '邮箱': 'Email',
        '请输入邮箱地址': 'Please enter email address',
        '请输入邮箱': 'Please enter email',
        '请输入正确的邮箱格式': 'Please enter the correct email format',
        '需求': 'Requirement',
        '请描述您的需求': 'Please describe your requirement',
        '提交': 'Submit',
        '请填写需求': 'Please fill in requirement',
        '续费成功': 'Renewal successful! Membership validity has been extended',
        '已取消订阅': 'Subscription canceled, membership will expire after the current period',
        '提交成功': 'Submitted successfully, we will contact you as soon as possible!',
    },
    Task: {
        '生成任务': 'Generation Tasks',
        '新建任务': 'New Task',
        '进行中': 'In Progress',
        '已完成': 'Completed',
        '失败': 'Failed',
        '队列中': 'Queued',
        '活跃任务': 'Active Tasks',
        '刷新': 'Refresh',
        '暂无活跃任务': 'No active tasks yet',
        '预计剩余': 'Estimated remaining',
        '暂停': 'Pause',
        '继续': 'Continue',
        '取消': 'Cancel',
        '最近完成': 'Recently Completed',
        '查看全部': 'View All',
        '暂无完成的任务': 'No completed tasks yet',
        '播放': 'Play',
        '下载': 'Download',
        '分享': 'Share',
        '确认取消': 'Confirm Cancel',
        '确定要取消任务吗': 'Are you sure you want to cancel the task',
        '已消耗的额度将无法退还': 'Consumed quota will not be refunded',
        '返回': 'Return',
        '分享作品': 'Share Work',
        '复制链接': 'Copy Link',
        '任务列表已刷新': 'Task list has been refreshed',
        '已暂停': 'Paused',
        '生成中': 'Generating',
        '已恢复': 'Resumed',
        '任务已取消': 'Task canceled',
        '链接已复制到剪贴板': 'Link copied to clipboard',
    },
    VideoShow: {
        '示例': 'Examples',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'A carefully curated selection of clips from our demo library. Click on any card to start generating content with a similar style.',
        '全部': 'All',
        '电影感': 'Cinematic',
        '角色': 'Characters',
        '产品': 'Products',
        '自然': 'Nature',
        '趣味': 'Fun',
        '加载中': 'Loading',
        '暂无展示': 'No demos available',
        '视频预览': 'Video Preview',
    },
    Request: {
        "加载中": "Loading...",
        "您已退出登录": "You have logged out. You can log in again.",
        "确认退出": "Confirm logout",
        "重新登录": "Log in again",
        "错误": "Error",
        "网络错误": "Network error",
        "下载中": "Downloading..."
    },
    Other: {
        "剩余额度": "Remaining balance",
        "去登录": "Log in",
        "请登录后查看": "Please log in to view",
        "任务": "Task",
        "可在「生成任务」中查看详情": "You can view details in \"Generation Tasks\"",
        "查看详情": "View details",
        "排队中": "Queuing",
        "运行中": "Running",
        "取消": "Cancel",
        "成功": "Success",
        "失败": "Failed",
        "超时": "Timeout",
        "最后更新": "Last updated:",
        "视频生成": "Video Generation",
        "活跃用户": "Active Users",
        "用户评分": "User Rating",
        "万": "W",
        "快速生成": "Fast Generation",
        "先进的AI模型": "Advanced AI model that generates high-quality videos in minutes",
        "多种风格": "Multiple Styles",
        "多种风格任您选择": "Realistic, anime, artistic and more styles to choose from",
        "高清输出": "High-Definition Output",
        "支持4K超高清视频输出": "Supports 4K ultra-HD video output with crystal clear details",
        "商用授权": "Commercial License",
        "生成的视频可用于商业用途": "Generated videos can be used for commercial purposes, no copyright concerns",
        "原价": "Original price",
        "积分价格说明": "Credit pricing details",
        "系列": "Series",
        "模型": "Model",
        "分辨率": "Resolution",
        "积分": "Credits",
        "秒": "seconds",
        "秒示例": "sec example",
        "图片模型": "Image Model",
        "图片为": "Image is for",
        "系列产品": "series product, currently supports",
        "支持使用任意机型查看完整体验": ", supports viewing full experience on any device model",
        "计费方式": "Billing method",
        "张": "image(s)",
        "按生成张数计费": "Billed by number of generated images",
        "普通用户": "Regular user",
        "无记录": "No records",
        "总支出": "Total spending",
        "月总使用": "Monthly total usage",
        "月视频使用": "Monthly video usage",
        "月图片使用": "Monthly image usage",
        "生成成功": "Generation successful",
        "视频总生成": "Total videos generated",
        "图片总生成": "Total images generated",
        "生成中": "Generating, please wait 1-3 minutes",
        "来自我们演示库的一套精心挑选的剪辑片段": "A carefully selected collection of clips from our demo library.",
        '最近7天': 'Last 7 days',
        '最近30天': 'Last 30 days',
        '本月': 'This month',
        '上月': 'Last month',
        '选择支付方式': 'Select payment method',
        '确认支付': 'Confirm payment'
    }
}